export const AzureStorage = 0;
export const Email = 1;
export const Queue = 2;